import React, { useState } from "react";
import { Menu, MenuItem, IconButton } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie"; // Import js-cookie for managing cookies
import "./AccountDropdown.scss";

const AccountDropdown = ({ setIsLoggedIn }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const username = Cookies.get("username");

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleProfileClick = () => {
    handleMenuClose();
    navigate("account"); // Navigate to account details
  };

  const handleGroupClick = () => {
    handleMenuClose();
    navigate("group-settings");
  };

  const handleLogout = () => {
    Cookies.remove("session_key");
    Cookies.remove("username");
    setIsLoggedIn(false);
    navigate("/login");
  };

  return (
    <div
      className="AccountDropdown"
      style={{ color: "white", marginRight: "15px" }}
    >
      <IconButton
        aria-controls="account-menu"
        aria-haspopup="true"
        onClick={handleMenuOpen}
        color="inherit"
        sx={{
          width: "48px", // Increase width
          height: "48px",
        }}
      >
        <AccountCircleIcon sx={{ fontSize: "36px" }} />
      </IconButton>
      {username && (
        <span style={{ fontSize: "14px", fontWeight: "bold", marginLeft: "4px" }}>
          {username}
        </span>
      )}
      {/* <p style={{ fontSize: "12px", margin: "0", fontWeight: "bold" }}>
        Account
      </p>{" "} */}
      {/* Add label */}
      <Menu
        id="account-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        keepMounted
      >
        <MenuItem onClick={handleProfileClick}>Account Settings</MenuItem>
        <MenuItem onClick={handleGroupClick}>Group Settings</MenuItem>
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </div>
  );
};

export default AccountDropdown;
